import { inject } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, ParamMap } from '@angular/router';
import { Observable, of } from 'rxjs';
import { ConfigProvider } from '../../config-provider.service';
import { CurrentUser } from "../providers/current-user";

export const HasHomepageRedirectGuard = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> => {
  const router = inject(Router);
  const configProvider = inject(ConfigProvider);
  const currentUser = inject(CurrentUser);
  return new Observable((observer) => {
    if (!currentUser.isLoggedIn() && configProvider.homepageRedirect) {
      const paramsString = buildParamsString(route.queryParamMap);
      router.navigateByUrl(configProvider.homepageRedirect + paramsString).then(() => {
        observer.next(false);
        observer.complete();
      });
    } else {
      observer.next(true);
      observer.complete();
    }
  });
};

function buildParamsString(params: ParamMap): string {
  if (params.keys.length > 0) {
    const items: string[] = params.keys.map(key => `${key}=${params.get(key)}`);
    return '?' + items.join('&');
  }
  return '';
}
